// スクロールアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // アニメーション対象要素
  document.querySelectorAll('.award-item, .youtube-content, .sw-content-card').forEach(el => {
    observer.observe(el);
  });
});



// スクロールアニメーション
document.addEventListener('DOMContentLoaded', function() {
  const observerOptions = {
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  // アニメーション対象要素
  document.querySelectorAll('.award-item, .youtube-content, .sw-content-card').forEach(el => {
    observer.observe(el);
  });
});



// アイコン横流し + タップ拡大 + ドットナビゲーション
(function() {
  var track = document.getElementById('swIconsTrack');
  if (!track) return;

  // 無限ループ用に複製
  var clone = track.cloneNode(true);
  clone.setAttribute('aria-hidden', 'true');
  var wrap = track.parentElement;
  wrap.appendChild(clone);

  var pos = 0;
  var speed = 0.6; // px/frame
  var isPaused = false;
  var trackWidth = track.scrollWidth + 16; // gap分

  // 複製前のオリジナルカード一覧
  var originalCards = Array.prototype.slice.call(track.querySelectorAll('.sw-icon-flow-card'));

  // 各カードの「コンテンツ座標(=wrap.scrollLeftと同じ基準)」を一度だけ計算
  function calcCardPositions() {
    return originalCards.map(function(card) {
      var rect = card.getBoundingClientRect();
      var wrapRect = wrap.getBoundingClientRect();
      return (rect.left - wrapRect.left) + wrap.scrollLeft;
    });
  }
  var cardPositions = calcCardPositions();
  window.addEventListener('resize', function() {
    cardPositions = calcCardPositions();
  });

  function tick() {
    if (!isPaused) {
      pos += speed;
      if (pos >= trackWidth) pos -= trackWidth;
      wrap.scrollLeft = pos;
    }
    updateActiveDot();
    requestAnimationFrame(tick);
  }
  wrap.style.overflowX = 'hidden';
  wrap.style.scrollBehavior = 'auto';
  requestAnimationFrame(tick);

  wrap.addEventListener('mouseenter', function() { isPaused = true; });
  wrap.addEventListener('mouseleave', function() { isPaused = false; });

  // ===== タップ/クリックで拡大 =====
  var modal = document.getElementById('swIconModal');
  var modalImg = document.getElementById('swIconModalImg');
  var modalClose = document.getElementById('swIconModalClose');
  var modalPrev = document.getElementById('swIconModalPrev');
  var modalNext = document.getElementById('swIconModalNext');
  var currentIndex = 0;

  function showSlide(index) {
    currentIndex = (index + originalCards.length) % originalCards.length;
    var img = originalCards[currentIndex].querySelector('img');
    modalImg.src = img.currentSrc || img.src;
    modalImg.alt = img.alt;
  }

  function openModal(card) {
    var idx = originalCards.indexOf(card);
    showSlide(idx === -1 ? 0 : idx);
    modal.classList.add('is-open');
    isPaused = true;
  }

  function closeModal() {
    modal.classList.remove('is-open');
    isPaused = false;
  }

  wrap.addEventListener('click', function(e) {
    var card = e.target.closest('.sw-icon-flow-card');
    if (card) openModal(card);
  });

  modalClose.addEventListener('click', closeModal);
  modalPrev.addEventListener('click', function() { showSlide(currentIndex - 1); });
  modalNext.addEventListener('click', function() { showSlide(currentIndex + 1); });
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') showSlide(currentIndex - 1);
    if (e.key === 'ArrowRight') showSlide(currentIndex + 1);
    if (e.key === 'Escape') closeModal();
  });

  // ===== ドットナビゲーション =====
  var dotsWrap = document.getElementById('swIconsDots');
  if (!dotsWrap) return;

  var resumeTimer = null;

  originalCards.forEach(function(card, i) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'sw-dot';
    dot.setAttribute('role', 'tab');
    dot.setAttribute('aria-label', card.dataset.desc || ('スライド' + (i + 1)));
    dot.addEventListener('click', function() {
      pos = cardPositions[i];
      wrap.scrollLeft = pos;
      isPaused = true;

      // 一定時間後に自動流しを再開
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function() {
        isPaused = false;
      }, 3000);
    });
    dotsWrap.appendChild(dot);
  });

  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.sw-dot'));

  function updateActiveDot() {
    var centerPos = pos + wrap.clientWidth / 2;
    var closestIndex = 0;
    var closestDist = Infinity;

    cardPositions.forEach(function(cardPos, i) {
      var cardWidth = originalCards[i].clientWidth;
      var cardCenter = cardPos + cardWidth / 2;
      var dist = Math.abs(cardCenter - centerPos);
      if (dist < closestDist) {
        closestDist = dist;
        closestIndex = i;
      }
    });

    dots.forEach(function(dot, i) {
      dot.classList.toggle('is-active', i === closestIndex);
    });
  }
})();


// みんなの感想（一覧表示・投稿）
(function () {
  var API_URL = 'https://xs004446.xsrv.jp/wine-review-api/reviews.php';
  var PAGE_KEY = 'spainwine-event';

  var listEl = document.getElementById('swReviewList');
  var formEl = document.getElementById('swReviewForm');
  var messageEl = document.getElementById('swReviewFormMessage');

  if (!listEl || !formEl) return;

  var PAGE_SIZE = 10;
  var allReviews = [];
  var visibleCount = PAGE_SIZE;

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function starString(rating) {
    rating = parseInt(rating, 10) || 0;
    return '★★★★★☆☆☆☆☆'.slice(5 - rating, 10 - rating);
  }

  function reviewItemHtml(r) {
    var date = (r.created_at || '').split(' ')[0];
    return (
      '<div class="sw-review-item">' +
        '<div class="sw-review-item-header">' +
          '<span class="sw-review-item-name">' + escapeHtml(r.nickname) + '</span>' +
          '<span class="sw-review-item-stars">' + starString(r.rating) + '</span>' +
        '</div>' +
        '<p class="sw-review-item-comment">' + escapeHtml(r.comment) + '</p>' +
        '<span class="sw-review-item-date">' + escapeHtml(date) + '</span>' +
      '</div>'
    );
  }

  function renderReviews() {
    if (!allReviews.length) {
      listEl.innerHTML = '<p class="sw-review-empty">まだ感想が投稿されていません。一番乗りで投稿してみませんか？</p>';
      return;
    }

    var visible = allReviews.slice(0, visibleCount);
    var html = visible.map(reviewItemHtml).join('');

    if (visibleCount < allReviews.length) {
      html += '<button type="button" id="swReviewLoadMore" class="sw-review-load-more">もっと見る</button>';
    }

    listEl.innerHTML = html;

    var loadMoreBtn = document.getElementById('swReviewLoadMore');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += PAGE_SIZE;
        renderReviews();
      });
    }
  }

  function loadReviews() {
    fetch(API_URL + '?page_key=' + encodeURIComponent(PAGE_KEY))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.ok) {
          allReviews = data.reviews || [];
          visibleCount = PAGE_SIZE;
          renderReviews();
        } else {
          listEl.innerHTML = '<p class="sw-review-empty">読み込みに失敗しました。</p>';
        }
      })
      .catch(function () {
        listEl.innerHTML = '<p class="sw-review-empty">読み込みに失敗しました（通信エラー）。</p>';
      });
  }

  var ERROR_MESSAGES = {
    'invalid_json': '送信データが正しくありません。ページを再読み込みして再度お試しください。',
    'validation_failed': '入力内容をご確認ください。',
    'too_many_requests': '短時間に連続して投稿されたため、少し時間をおいてから再度お試しください。',
    'db_connection_failed': 'ただいまサーバーが混み合っています。しばらくしてから再度お試しください。',
    'method_not_allowed': 'エラーが発生しました。ページを再読み込みしてください。'
  };

  function errorMessageFor(code) {
    return ERROR_MESSAGES[code] || 'エラーが発生しました。しばらくしてから再度お試しください。';
  }

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    messageEl.textContent = '';
    messageEl.className = 'sw-review-form-message';

    var nickname = document.getElementById('swReviewNickname').value.trim();
    var comment = document.getElementById('swReviewComment').value.trim();
    var website = document.getElementById('swReviewWebsite').value.trim();
    var ratingInput = formEl.querySelector('input[name="sw_rating"]:checked');
    var rating = ratingInput ? ratingInput.value : 0;

    if (!nickname || !comment || !rating) {
      messageEl.textContent = 'お名前・評価・感想をすべて入力してください。';
      messageEl.className = 'sw-review-form-message is-error';
      return;
    }

    var btn = formEl.querySelector('.sw-review-submit');
    btn.disabled = true;

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page_key: PAGE_KEY,
        nickname: nickname,
        rating: rating,
        comment: comment,
        website: website
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        btn.disabled = false;
        if (data.ok) {
          formEl.reset();
          messageEl.textContent = '投稿ありがとうございます！確認後に掲載されます。';
          messageEl.className = 'sw-review-form-message is-success';
        } else {
          messageEl.textContent = errorMessageFor(data.error);
          messageEl.className = 'sw-review-form-message is-error';
        }
      })
      .catch(function () {
        btn.disabled = false;
        messageEl.textContent = '通信エラーが発生しました。しばらくしてから再度お試しください。';
        messageEl.className = 'sw-review-form-message is-error';
      });
  });

  loadReviews();
})();

